module.exports = __webpack_public_path__ + "img/2.1c6f9476.png";